import initMK from '../_core/init.js';
import forOwn from '../_helpers/forown.js';
// converts Matreshka.Object instance to ordinary object
export default function toJSON(recursive) {
  var _this = this;
  if (recursive === void 0) {
    recursive = true;
  }
  var _initMK = initMK(this),
    keys = _initMK.keys;
  var result = {};
  forOwn(keys, function (_, key) {
    var value = _this[key];
    // when recursive is true and when value has toJSON method then call it recusively
    // defined, not assigned: a data key named __proto__ is a key, not the result's prototype
    Object.defineProperty(result, key, {
      value: recursive && value && typeof value.toJSON === 'function' ? value.toJSON(true) : value,
      enumerable: true,
      writable: true,
      configurable: true
    });
  });
  return result;
}